import { generateTable } from '../../table/Table';
import { fetchContexts, fetchKapps } from '../../../apis';
import { defineFilter } from '../../../helpers';
var clientSide = defineFilter(true).startsWith('kapp', 'kapp').startsWith('form', 'form').startsWith('name', 'context').end();

var dataSource = function dataSource() {
  return {
    fn: fetchContexts,
    clientSide: clientSide,
    params: function params() {
      return [{
        include: 'authorization,details',
        expected: true
      }];
    },
    transform: function transform(result) {
      return {
        data: result.contexts,
        nextPageToken: result.nextPageToken
      };
    }
  };
};

var filterDataSources = function filterDataSources() {
  return {
    kapps: {
      fn: fetchKapps,
      params: function params() {
        return [{
          include: 'details'
        }];
      },
      transform: function transform(result) {
        return result.kapps.map(function (kapp) {
          return {
            label: kapp.slug,
            value: kapp.slug
          };
        });
      }
    }
  };
};

var filters = function filters() {
  return function (_ref) {
    var kapps = _ref.kapps;
    return kapps && [{
      name: 'context',
      label: 'Context Type',
      type: 'select',
      options: ['Kapp', 'Datastore', 'Custom'].map(function (el) {
        return {
          value: el,
          label: el === 'Kapp' ? 'Form' : el
        };
      }),
      onChange: function onChange(_bindings, _ref2) {
        var setValue = _ref2.setValue;
        setValue('kapp', '');
        setValue('form', '');
      }
    }, {
      name: 'kapp',
      label: 'Kapp Slug',
      type: 'select',
      enabled: function enabled(_ref3) {
        var values = _ref3.values;
        return values.get('context') === 'Kapp';
      },
      options: kapps
    }, {
      name: 'form',
      label: 'Form Slug',
      type: 'text'
    }];
  };
};

var columns = [{
  value: 'kapp',
  title: 'Kapp Slug',
  sortable: true
}, {
  value: 'form',
  title: 'Form Slug',
  sortable: true
}, {
  value: 'name',
  title: 'Context Name',
  sortable: true
}];
export var ContextTable = generateTable({
  columns: columns,
  filters: filters,
  dataSource: dataSource,
  filterDataSources: filterDataSources
});
ContextTable.displayName = 'ContextTable';